module.exports = __webpack_public_path__ + "static/media/rounded-rect-secondary.6accdd42.png";